module.exports = __webpack_public_path__ + "media/images/products/retailers-socialmedia-4-buy-pages-c3e46b47e20a0d1bfc94f24543b2ebcd.jpg";